import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subject, takeUntil } from "rxjs";
import { InventoryService } from "src/app/services/inventory.service";
import { HeaderService } from "../header/header.service";
import { SnackbarComponent } from "../snackbar/snackbar.component";

@Component({
  selector: 'app-create-product-dialog',
  templateUrl: './create-product-dialog.component.html',
  styleUrls: ['./create-product-dialog.component.scss']
})
export class CreateProductDialogComponent implements OnInit, OnDestroy {
  spin:boolean = false;
  radioOption: FormControl = new FormControl("SKU");
  selectedVendor: FormControl = new FormControl(null);
  account:string;
  radioButtonOptions = [{
    value: 'SKU',
    name: 'SKU'
  }, {
    value: 'ASIN',
    name: 'ASIN'
  }]
  title: string;
  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<CreateProductDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private inventoryService: InventoryService,
    private snackBar: MatSnackBar,
    private headerService: HeaderService
  ) { }

  ngOnInit(): void {
    this.title = 'Quick mapping for '+this.data.accountSelected;
  }

  dialogAction(e) {
    if (e === "Create") {
      this.createProduct();
    } else {
      this.close();
    }
  }

  createProduct() {
    this.spin = true;
    const isSkus = this.radioOption.value === 'SKU' ? true : false;
    const payload: any = {
      type: this.data.channelType,
      account: this.data.accountSelected,
      vendorId: Number(+this.selectedVendor.value),
      isSku: isSkus
    }

    this.inventoryService.SetItemSkuLargeRecordMapping(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
      if (res) {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: "Operation successful",
              action: 'Dismiss',
              type: 'success',
            },
          }
        );
      }
      this.inventoryService.updateUnmappedSkus$.next(true);
      this.spin = false;
      this.close();
    },
      error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: "Operation Unsuccessful",
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
        this.inventoryService.updateUnmappedSkus$.next(true);
        this.spin = false;
        this.close();
       }
     });
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
